import z from "zod";
import { userSchema } from "../user";
import { createZodDto } from "nestjs-zod/dto";

export const withdrawalSchema = z.object({
  id: z.string(),
  reference: z.string(),
  demandDate: z.coerce.date(),
  decisionDate: z.coerce.date().nullable().optional(),
  userId: z.string(),
  amount: z.number(),
  status: z.enum(["accepted", "rejected", "pending"]).default("pending"),
  mean: z.enum(["MOBILE_MONEY", "BANK_TRANSACTION"]).default("MOBILE_MONEY").nullable(),
  phoneMomo: z.string().nullish(),
  bankNumber: z.string().nullish(),
  /** Traçabilité de la décision — qui a validé/rejeté, quand, et pourquoi. */
  decidedById: z.string().nullish(),
  decisionNote: z.string().nullish(),
  decidedBy: z.object({ id: z.string(), name: z.string(), email: z.string() }).nullish(),
});

export class WithdrawalDto extends createZodDto(withdrawalSchema) {}

const withdrawalWithUserSchema = withdrawalSchema.merge(z.object({ user: userSchema }));

export class WithdrawalWithUser extends createZodDto(withdrawalWithUserSchema) {}
